var _rect, _rect2, _rect3, _rect4, _rect5, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtsconnect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "url(#atsConnectGrad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 10,
    height: 10,
    rx: 2.5,
    fill: "#ffffff",
    fillOpacity: 0.95
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 11,
    width: 10,
    height: 10,
    rx: 2.5,
    fill: "#ffffff",
    fillOpacity: 0.75
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 27,
    width: 10,
    height: 10,
    rx: 2.5,
    fill: "#ffffff",
    fillOpacity: 0.75
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    width: 10,
    height: 10,
    rx: 2.5,
    fill: "#ffffff",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 29.5v5M29.5 32h5",
    stroke: "#ffffff",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "atsConnectGrad",
    x1: 0,
    y1: 0,
    x2: 48,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0891B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7490"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtsconnect);
export default __webpack_public_path__ + "static/media/atsconnect.c84c87cb52279531020f5cd59ba245e2.svg";
export { ForwardRef as ReactComponent };